
import React from "react";
import "@fontsource/dancing-script";

interface LogoProps {
  className?: string;
  imagePath?: string;
  horizontal?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className, imagePath, horizontal = false }) => {
  // Using the provided Grade Test Pro logo URL
  const logoUrl = "https://n-micro.ca/images/gradetestpro.png"; 
  
  return (
    <div className={`flex ${horizontal ? "flex-row items-center" : "flex-col items-center"} ${className || ""}`}>
      <img 
        src={imagePath || logoUrl} 
        alt="Grade Test Pro Logo" 
        className={`${horizontal ? "mr-3" : ""} rounded-full object-cover`}
        width={48}
        height={48}
        style={{ width: '48px', height: '48px' }}
        onError={(e) => {
          console.error('Logo failed to load:', logoUrl);
          e.currentTarget.style.display = 'none';
        }}
      />
      <div
        className={`${horizontal ? "" : "mt-2"} text-xl sm:text-2xl tracking-tight leading-tight text-foreground whitespace-nowrap`}
        style={{ fontFamily: "'Bubblegum Sans', cursive" }}
      >
        Grade Test{" "}
        <span className="bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
          Pro
        </span>
      </div>
    </div>
  );
};

export default Logo;
